var googleMapInit;

(function ($) {

	const selectors = {
		wrapper: '[data-google-map]',
		map: '[data-google-map-map]',
	}


	googleMapInit = function () {
		$(selectors.wrapper).each((i, el) => {
			new GoogleMap(el);
		});
	}

	class GoogleMap {
		constructor(element) {

			this.$wrap = $(element);
			this.$map = $(selectors.map, this.$wrap);

			if (this.$map.length) {
				this.init();
			}

		}
		init() {


			const self = this;

			var latLng = {
				lat: parseFloat(self.$map.attr('data-lat')),
				lng: parseFloat(self.$map.attr('data-lng'))
			};

			// Create gerenic map.
			var mapArgs = {
				zoom: self.$map.data('zoom') || 14,
				center: latLng,
				mapTypeId: self.$map.attr('data-type') || 'roadmap',
				styles: [{ "featureType": "administrative", "elementType": "labels.text.fill", "stylers": [{ "color": "#444444" }] }, { "featureType": "landscape", "elementType": "all", "stylers": [{ "color": "#f2f2f2" }] }, { "featureType": "poi", "elementType": "all", "stylers": [{ "visibility": "off" }] }, { "featureType": "road", "elementType": "all", "stylers": [{ "saturation": -100 }, { "lightness": 45 }] }, { "featureType": "road.highway", "elementType": "all", "stylers": [{ "visibility": "simplified" }] }, { "featureType": "road.arterial", "elementType": "labels.icon", "stylers": [{ "visibility": "off" }] }, { "featureType": "transit", "elementType": "all", "stylers": [{ "visibility": "off" }] }, { "featureType": "water", "elementType": "all", "stylers": [{ "color": "#01bdff" }, { "visibility": "on" }] }]
			};

			self.googleMap = new google.maps.Map(self.$map[0], mapArgs);

			self.marker = new google.maps.Marker({
				position: latLng,
				map: self.googleMap,
				cursor: 'default',
			});

		}
	}

})(jQuery);

export default googleMapInit;